import { render, staticRenderFns } from "./CreateAndEditEntity.vue?vue&type=template&id=93e65e52&"
import script from "./CreateAndEditEntity.vue?vue&type=script&lang=js&"
export * from "./CreateAndEditEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports